module.exports = __webpack_public_path__ + "static/media/python.45fa1cac.png";